const reduceSearchParam = (searchParams, kv) => {
    // tslint:disable-next-line:prefer-const
    let [key, value] = kv.split('=');
    key = decodeURIComponent(key);
    if (key.startsWith('!')) {
        searchParams[key.substr(1)] = false;
    }
    else if (key.endsWith('[]')) {
        key = key.substr(0, key.length - 2);
        searchParams[key] = [
            ...(searchParams[key] || []),
            ...(value || '').split(',').map(decodeURIComponent)
        ];
    }
    else {
        searchParams[key] = value ? decodeURIComponent(value) : true;
    }
    return searchParams;
};
export const parseSearchParams = (searchString) => searchString.split('&').reduce(reduceSearchParam, {});
export const searchParams = typeof window === 'undefined' ? {} : parseSearchParams(location.search.substr(1));
